import {pillWrapper} from '../pill-wrapper';

import Svg from './keep-nutshell.svg';

interface Props {
    height?: number;
    width?: number;
}

function SvgComponent(props: Props) {
    return <Svg height={props.height} width={props.width} />;
}

export const KeepNutshellPill = pillWrapper(SvgComponent);
